import {ParsedUrlQuery} from 'querystring'

import React from 'react'

import {GetStaticProps} from 'next'

import SEO from 'components/elements/SEO'
import LayoutAccount from 'components/layouts/LayoutAccount'
import TemplatePricing from 'components/templates/TemplatePricing'
import {TPageComponent} from 'src/types'

interface IPricingPageProps {
	slug: string
}

const PricingPage: TPageComponent<IPricingPageProps> = ({slug}) => {
	return (
		<>
			<SEO
				keywords="paystub generator pricing"
				title="Online Paystub Generator Pricing Plans - Paystub.org"
				description="Save time and money with an online paystub generator. Check out our pricing plans for an online paycheck generator to get the most value for your money."
			/>
			<TemplatePricing pricingSlug={slug} />
		</>
	)
}

export async function getStaticPaths() {
	return {
		paths: [
			'monthly',
			'monthly-a',
			'monthly-b',
			// NOTE we should leave the old flag keys for backward compatibility. Because there are still users with the old data in the cookies.
			'monthly-c',
			'monthly-d',
			'monthly-e',
			'monthly-f',
		].map((plan) => ({
			params: {
				ab: plan,
			},
		})),
		fallback: false,
	}
}

interface IParams extends ParsedUrlQuery {
	ab: string
}

export const getStaticProps: GetStaticProps = (context) => {
	const {ab = 'monthly'} = context.params as IParams
	return {
		props: {
			slug: ab,
		},
	}
}

PricingPage.displayName = 'PricingPage'
PricingPage.Layout = LayoutAccount

export default PricingPage
